import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'rateCurrency' })
export class RateCurrency implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {}

    transform(value: any, currencyCode?: string, locale?: any): string {
        if (value != undefined) {
            let output = this.currencyPipe.transform(value, currencyCode, 'symbol', '1.4-4', locale);
            return output.replace('€', '');
        } else {
            return 'NA';
        }
    }
}
